// extracted by mini-css-extract-plugin
export default {"credits":"MapCredits_credits__zbasG","credit":"MapCredits_credit__ksSjg","creditLink":"MapCredits_creditLink__xXwIR"};